export const PERMISSIONS = {
  ARTICLE_VIEW: 'article.view',
  ARTICLE_CREATE: 'article.create',
  ARTICLE_UPDATE_OWN: 'article.update.own',
  ARTICLE_UPDATE_ANY: 'article.update.any',
  ARTICLE_DELETE: 'article.delete',
  ARTICLE_PUBLISH: 'article.publish',
  ARTICLE_ARCHIVE: 'article.archive',
  ARTICLE_RESTORE_VERSION: 'article.restoreVersion',
  ARTICLE_FEATURED: 'article.featured',

  SSS_VIEW: 'sss.view',
  SSS_CREATE: 'sss.create',
  SSS_UPDATE: 'sss.update',
  SSS_DELETE: 'sss.delete',
  SSS_PUBLISH: 'sss.publish',
  SSS_RESTORE_VERSION: 'sss.restoreVersion',

  PAGE_VIEW: 'page.view',
  PAGE_CREATE: 'page.create',
  PAGE_UPDATE: 'page.update',
  PAGE_DELETE: 'page.delete',
  PAGE_PUBLISH: 'page.publish',

  CAMPAIGN_VIEW: 'campaign.view',
  CAMPAIGN_CREATE: 'campaign.create',
  CAMPAIGN_UPDATE: 'campaign.update',
  CAMPAIGN_DELETE: 'campaign.delete',
  CAMPAIGN_PUBLISH: 'campaign.publish',
  CAMPAIGN_ARCHIVE: 'campaign.archive',
  CAMPAIGN_RESTORE_VERSION: 'campaign.restoreVersion',

  WORKFLOW_QUEUE_VIEW: 'workflow.queue.view',

  // K-6 — CustomCode (ham HTML/JS/JSON-LD) alanının YAZIMI. content.write'tan
  // ayrı, dar bir yetkidir (seed: SuperAdmin+Admin); BE guard'ı alan
  // değişiyorsa bu izni ister. Page/Article/Campaign editörlerinde alanı kapılar.
  CONTENT_CUSTOM_CODE: 'content.customcode',

  WEB_REDIRECT: 'web.redirect',
  WEB_OG_PREVIEW: 'web.manage',

  // MOD-03 / MOD-10 / ENT-08 — config-tier site bileşenleri. Hepsi BE'de tek
  // `web.manage` policy'siyle korunur (FE anahtarları ayrık tutulur).
  MENU_MANAGE: 'menu.manage',
  SLIDER_MANAGE: 'slider.manage',
  BANNER_MANAGE: 'banner.manage',
  POPUP_MANAGE: 'popup.manage',

  // MOD-17 / REQ-50 / K-1 — Component Studio: yeniden kullanılabilir sayfa-yapıcı
  // bileşenlerinin tanımlanması (oluştur/güncelle/yayınla/arşivle/versiyon geri
  // yükleme). Kendi dar `components.manage` policy'siyle korunur (web.manage'den
  // AYRI; seed: Admin+Editör). Palet/liste OKUMASI izin gerektirmez (BE `[Authorize]`)
  // — bu anahtar yalnız yazma/aksiyon butonlarını kapılar.
  COMPONENT_MANAGE: 'components.manage',

  KVKK_DELETION_MANAGE: 'kvkk.manage',
  KVKK_UNMASK: 'kvkk.unmask',
  USERS_MANAGE: 'users.manage',
  ADMIN_USER_MANAGE: 'adminUser.manage',
  ROLE_MANAGE: 'role.manage',

  DASHBOARD_VIEW: 'dashboard.read',
  FILES_READ: 'files.read',
  FILES_WRITE: 'files.write',
  FILES_DELETE: 'files.delete',

  // MOD-07 — form yönetimi. Başvuru (submission) PII taşıdığı için ayrı izin
  // (BE Permissions.cs: form.view/form.manage/form.submissions).
  FORM_VIEW: 'form.view',
  FORM_MANAGE: 'form.manage',
  FORM_SUBMISSIONS: 'form.submissions',

  // MOD-11 — şube/lokasyon yönetimi. branch.view liste/detay okumayı, branch.manage
  // CRUD'u kapılar (BE Permissions.cs: branch.view/branch.manage). İçerik ekibinden
  // ayrı izinler — bankanın fiziksel lokasyon verisi bağımsız denetlenebilir.
  BRANCH_VIEW: 'branch.view',
  BRANCH_MANAGE: 'branch.manage',

  AUDIT_LOG_VIEW: 'audit.view',
  CATEGORY_MANAGE: 'category.manage',
  TAG_MANAGE: 'tag.manage',
  AUTHOR_MANAGE: 'author.manage',
  TRANSLATION_MANAGE: 'translations.manage',
  SETTINGS_MANAGE: 'settings.manage',
  // MOD-04 — güvenlik yönetimi gate'i (IP allowlist CRUD + başka bir kullanıcının
  // 2FA'sını sıfırlama). BE'de settings.manage'den ayrı tutulur (BIZ-SEC-04),
  // böylece bankanın güvenlik yüzeyi bağımsız denetlenebilir.
  SECURITY_MANAGE: 'security.manage',

  // REQ-45 / K-3 — çoklu-site (proje) yönetimi: Proje CRUD + kullanıcı↔proje
  // atama. Proje SEÇMEK (X-Project-Id) izin gerektirmez; üyelikle sınırlıdır
  // (SuperAdmin tümünü görür). BE Permissions.cs: project.manage.
  PROJECT_MANAGE: 'project.manage',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export const ROLE = {
  ADMIN: 'ADMIN',
  EDITOR: 'EDITOR',
  WRITER: 'WRITER',
} as const;

export type Role = (typeof ROLE)[keyof typeof ROLE];

// Role labels are resolved via i18n — see useRoleLabel() in
// @shared/constants/labels (keys under common:roles.*).
